import WiEPWebsite from './WiEPWebsite';

function App() {
  return (
    <WiEPWebsite />
  );
}

export default App;
